<div class="contract-view" *ngIf="contractData">
  <div class="contract-hero">
    <div class="contract-hero__client">
      <p class="contract-hero__label">Cliente</p>
      <h2 class="contract-hero__name">{{ contractData.Client || '-' }}</h2>
      <p class="contract-hero__doc">CPF/CNPJ {{ contractData.ClientDocument || '-' }}</p>
    </div>

    <div class="contract-hero__stats">
      <div class="contract-hero__stat">
        <p class="contract-hero__stat-label">Valor do Financiamento</p>
        <p class="contract-hero__stat-value">{{ (contractData.Amount | currency: 'BRL') || '-' }}</p>
      </div>
      <div class="contract-hero__stat">
        <p class="contract-hero__stat-label">Alíquota</p>
        <p class="contract-hero__stat-value">{{ (contractData.Fee !== null && contractData.Fee !== undefined) ? (contractData.Fee | number: '1.0-2') + '%' : '-' }}</p>
      </div>
      <div class="contract-hero__stat">
        <p class="contract-hero__stat-label">Produto</p>
        <p class="contract-hero__stat-value">{{ contractData.Product || '-' }}</p>
      </div>
      <div class="contract-hero__stat">
        <p class="contract-hero__stat-label">Banco</p>
        <p class="contract-hero__stat-value">{{ (contractData.FinancialInstitution | titlecase) || '-' }}</p>
      </div>
    </div>
  </div>

  <div class="contract-card" *ngIf="isEditMode">
    <p class="contract-card__edit-notice">Editando contrato — só os campos destacados abaixo podem ser alterados.</p>
  </div>

  <div class="contract-card">
    <h3 class="contract-card__title"><span class="contract-card__bar"></span>Identificação</h3>
    <div class="contract-card__grid">
      <div class="contract-field">
        <p class="contract-field__label">Contrato</p>
        <p class="contract-field__value">{{ contractData.Number || '-' }}</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">Versão</p>
        <p class="contract-field__value">{{ contractData.Version ?? '-' }}</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">Novo Contrato</p>
        <p class="contract-field__value contract-field__value--muted">Gerado apenas em caso de reemissão</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">Consulta</p>
        <p class="contract-field__value">{{ contractData.QueryNumber || '-' }}</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">Status do Contrato</p>
        <p class="contract-field__value">{{ contractData.StatusOverride || '-' }}</p>
      </div>
      <div class="contract-field" [class.contract-field--editable]="isFieldEditable('ContractDate')">
        <p class="contract-field__label">Data do Contrato</p>
        <app-c-input
          *ngIf="isFieldEditable('ContractDate'); else contractDateText"
          [formControl]="form.controls.ContractDate"
          inputType="datetime-local">
        </app-c-input>
        <ng-template #contractDateText>
          <p class="contract-field__value">{{ (contractData.ContractDate | date: 'dd/MM/yyyy HH:mm') || '-' }}</p>
        </ng-template>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">Data da Produção</p>
        <p class="contract-field__value">{{ (contractData.ContractDate | date: 'dd/MM/yyyy HH:mm') || '-' }}</p>
      </div>
    </div>
  </div>

  <div class="contract-card">
    <h3 class="contract-card__title"><span class="contract-card__bar"></span>Operação</h3>
    <div class="contract-card__grid">
      <div class="contract-field">
        <p class="contract-field__label">Banco</p>
        <p class="contract-field__value">{{ (contractData.FinancialInstitution | titlecase) || '-' }}</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">BPO/Regional</p>
        <p class="contract-field__value">{{ contractData.Bpo || '-' }}</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">Tipo de Operação</p>
        <p class="contract-field__value">{{ contractData.OperationType || '-' }}</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">Produto</p>
        <p class="contract-field__value">{{ contractData.Product || '-' }}</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">Canal</p>
        <p class="contract-field__value">{{ contractData.Chanel || '-' }}</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">Alíquota</p>
        <p class="contract-field__value">{{ (contractData.Fee !== null && contractData.Fee !== undefined) ? (contractData.Fee | number: '1.0-2') + '%' : '-' }}</p>
      </div>
      <div class="contract-field" [class.contract-field--editable]="isFieldEditable('Amount')">
        <p class="contract-field__label">Valor do Financiamento</p>
        <app-c-input
          *ngIf="isFieldEditable('Amount'); else amountText"
          [formControl]="form.controls.Amount"
          [inputMask]="'separator.6'"
          [currencyMask]="true">
        </app-c-input>
        <ng-template #amountText>
          <p class="contract-field__value">{{ (contractData.Amount | currency: 'BRL') || '-' }}</p>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="contract-card">
    <h3 class="contract-card__title"><span class="contract-card__bar"></span>Cliente</h3>
    <div class="contract-card__grid contract-card__grid--2col">
      <div class="contract-field">
        <p class="contract-field__label">Nome</p>
        <p class="contract-field__value">{{ contractData.Client || '-' }}</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">CPF/CNPJ</p>
        <p class="contract-field__value">{{ contractData.ClientDocument || '-' }}</p>
      </div>
    </div>
  </div>

  <div class="contract-card">
    <h3 class="contract-card__title"><span class="contract-card__bar"></span>Rede e Comissionados</h3>
    <div class="contract-card__grid">
      <div class="contract-field">
        <p class="contract-field__label">Parceiro</p>
        <p class="contract-field__value">{{ parceiro?.Name || '-' }}</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">CPF/CNPJ do Parceiro</p>
        <p class="contract-field__value">{{ parceiro?.Document || '-' }}</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">Subsidiária</p>
        <p class="contract-field__value">{{ subsidiaria?.Name || '-' }}</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">CPF/CNPJ da Subsidiária</p>
        <p class="contract-field__value">{{ subsidiaria?.Document || '-' }}</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">Afiliação</p>
        <p class="contract-field__value">{{ customField('afiliacao') }}</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">Consultor</p>
        <p class="contract-field__value">{{ customField('Consultor') }}</p>
      </div>
    </div>
  </div>

  <div class="contract-card">
    <h3 class="contract-card__title"><span class="contract-card__bar"></span>Observações</h3>

    <textarea
      *ngIf="isFieldEditable('Comments'); else commentsText"
      class="contract-card__textarea"
      rows="4"
      maxlength="240"
      [formControl]="form.controls.Comments">
    </textarea>
    <ng-template #commentsText>
      <p class="contract-card__text">{{ contractData.Comments || 'Nenhuma observação registrada.' }}</p>
    </ng-template>
  </div>
</div>
